module.exports = __webpack_public_path__ + "img/03.520cd33c.png";